import React from 'react';
import { COLORS } from '@constants';
import { useStore } from '@hooks';
import { Button, Icon, Typography } from '@ui';
import { Card, Flex } from 'antd';
import { observer } from 'mobx-react';

const ThemeExtensionNotification = observer(() => {
    const store = useStore();
    const { setupInfo, isShopify } = store.accountsStore;

    if (!isShopify || !setupInfo) {
        return null;
    }

    const themeExtension = setupInfo.themeExtension;

    if (!themeExtension || themeExtension.status === 'CONNECTED' || !themeExtension.hasRequiredScopes) {
        return null;
    }

    return (
        <Card data-e2e='home_theme-extension-notification' style={{ border: '2px solid #EF2E2E', marginBottom: 24 }}>
            <Flex vertical gap='middle'>
                <Typography.Title data-e2e='home_theme-extension-notification_title' level={2}>
                    Activate Klickly
                </Typography.Title>
                <Flex justify='space-between' gap={48}>
                    <Typography.Text type='headline3' style={{ fontWeight: 400 }}>
                        Open your Theme Editor in Shopify and click &ldquo;Save&rdquo;
                    </Typography.Text>
                    {themeExtension.enableUrl && (
                        <Button
                            data-e2e='home_theme-extension-enable_btn'
                            onClick={() => window.open(themeExtension.enableUrl, '_blank')}
                            type='primary'
                            size='large'
                            iconRight={
                                <Icon size='24px' color={COLORS.$white} component={() => <Icon.ArrowForwardIcon />} />
                            }
                        >
                            Activate
                        </Button>
                    )}
                </Flex>
            </Flex>
        </Card>
    );
});

export default ThemeExtensionNotification;
